export const BookWidgetStoreKey = 'bookWidgetStore';

export const RetrieveSearchMcCookieName = 'mc_cache_key';

export enum PaxTypeCodes {
  ADULT = 'ADT'
}

export const edocsLocalStorageKey = 'sfafEdocs';

export const maxFlightCountForMc = 6;

export enum searchModalTabIds {
  SEARCH = 'search',
  RECENT_SEARCH = 'recentSearch',
  SAVED_SEARCH = 'savedSearch'
}

export const RetrieveSearchTripTypeCookieName = 'trip_type';

export enum QUERY_PARAMS {
  CACHE_KEY_SUFFIX = 'cacheKeySuffix'
}
export enum HEADER {
  AUTHORIZATION = 'Authorization',
  BEARER = 'Bearer'
}
export enum SBW_TIMEOUT {
  PE_AE = 6000,
  COMMON = 32000,
  BFF_MAX_TIMEOUT = 65000
}

export enum TRIP_TYPE_IMAGES {
  OW = '/content/dam/delta-applications/sitewide/capability/flight-shop/images/one-way.svg',
  RT = '/content/dam/delta-applications/sitewide/capability/flight-shop/images/trip-icon.svg',
  MC = '/content/dam/delta-applications/sitewide/capability/flight-shop/images/multi-trip-icon.svg'
}
